import React, { useEffect, useState } from 'react';
import '../../pages/AdminPage.css';
import useAdminApi from '../../hook/useAdminApi';
import { IOrder } from '../../Types/Orders';
import { PopUp } from '../PopUp/PopUp';

const AdminRequests: React.FC = () => {
  const { getOrders, error, data, loading } = useAdminApi<IOrder[]>();
  const statusReq = useAdminApi<IOrder>();
  const deleteReq = useAdminApi<IOrder>();
  const deleteAllReq = useAdminApi<{ deleted: number }>();
  const [status, setStatus] = useState<'active' | 'canceled' | 'completed'>(
    'active',
  );
  const [type, setType] = useState<'order' | 'consultation'>('consultation');
  const [orders, setOrders] = useState<IOrder[]>();
  const [pop, setPop] = useState<boolean>(false);
  const [popMessage, setPopMessage] = useState('Не удалось изменить статус заявки!');
  const [deletingId, setDeletingId] = useState<string | null>(null);
  const [deletingAll, setDeletingAll] = useState(false);

  useEffect(() => {
    getOrders(type, status);
  }, [type, status]);

  useEffect(() => {
    if (data) {
      setOrders(data);
    }
  }, [data]);

  useEffect(() => {
    if (statusReq.data && !statusReq.error) {
      setOrders((v) => v?.filter((item) => item.id !== statusReq.data?.id));
    } else if (!statusReq.data && statusReq.error) {
      setPopMessage('Не удалось изменить статус заявки!');
      setPop(true);
    }
  }, [statusReq.data, statusReq.error]);

  useEffect(() => {
    if (deleteReq.data && !deleteReq.error) {
      setOrders((v) => v?.filter((item) => item.id !== deleteReq.data?.id));
      setDeletingId(null);
    } else if (!deleteReq.data && deleteReq.error) {
      setPopMessage('Не удалось удалить заявку!');
      setPop(true);
      setDeletingId(null);
    }
  }, [deleteReq.data, deleteReq.error]);

  const handleDelete = async (id: string) => {
    const ok = window.confirm(
      'Удалить заявку безвозвратно? Восстановить её будет нельзя.',
    );
    if (!ok) return;
    setDeletingId(id);
    try {
      await deleteReq.deleteOrder(id);
    } catch {
      setDeletingId(null);
    }
  };

  const handleDeleteAll = async () => {
    const count = orders?.length ?? 0;
    if (count === 0) return;
    const ok = window.confirm(
      `Удалить все отменённые заявки (${count}) безвозвратно?`,
    );
    if (!ok) return;
    setDeletingAll(true);
    try {
      await deleteAllReq.deleteAllCanceledOrders(type);
      setOrders([]);
    } catch {
      setPopMessage('Не удалось удалить все заявки!');
      setPop(true);
    } finally {
      setDeletingAll(false);
    }
  };

  return (
    <div className="main-content">
      <div className="content-header">
        <h1>
          <i className="fas fa-file-alt"></i> Заявки
        </h1>
        <div className="header-right">
          <select
            onChange={(e) => {
              setType(e.target.value as 'order' | 'consultation');
            }}
            style={{ padding: '6px 12px', fontSize: 16 }}
          >
            <option key="active" value="consultation">
              Консультации
            </option>
            <option key="completed" value="order">
              Заказы
            </option>
          </select>
          <select
            onChange={(e) => {
              setStatus(e.target.value as 'active' | 'canceled' | 'completed');
            }}
            style={{ padding: '6px 12px', fontSize: 16 }}
          >
            <option key="active" value="active">
              Активные
            </option>
            <option key="completed" value="completed">
              Завершённые
            </option>
            <option key="canceled" value="canceled">
              Отменённые
            </option>
          </select>
          <div className="total-products">
            <i className="fas fa-file-alt"></i>
            Всего заявок: <span>{data ? data.length : '-'}</span>
          </div>
          {status === 'canceled' ? (
            <button
              type="button"
              className="delete-button"
              disabled={deletingAll || !orders?.length}
              onClick={handleDeleteAll}
              title="Удалить все отменённые"
              style={{ padding: '8px 14px' }}
            >
              <i className="fas fa-trash"></i>{' '}
              {deletingAll ? 'Удаление...' : 'Удалить всё'}
            </button>
          ) : null}
        </div>
      </div>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя клиента</th>
              <th>Телефон</th>
              <th>Почта</th>
              <th>Статус</th>
              <th>Товар</th>
              <th>Комментарий</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {error && (
              <tr>
                <td colSpan={8} style={{ color: 'red' }}>
                  Что-то пошло не так
                </td>
              </tr>
            )}
            {orders?.length !== 0 && orders && loading ? (
              <tr>
                <td colSpan={8}>Загрузка заявок...</td>
              </tr>
            ) : null}
            {!loading && !error && data && data.length === 0 && (
              <tr>
                <td colSpan={8}>Заявки не найдены.</td>
              </tr>
            )}
            {data && orders && !loading
              ? orders.map((r) => (
                  <tr key={r.id}>
                    <td>{r.id}</td>
                    <td className="customer-name-col">{r.userName}</td>
                    <td>{r.tel}</td>
                    <td>{r.email}</td>
                    <td>{r.status}</td>
                    <td>{r.productId || '-'}</td>
                    <td className="review-text-cell">{r.comment || '-'}</td>
                    <td>
                      {status === 'completed' || status === 'canceled' ? (
                        <button
                          title="Вернуть в активные"
                          onClick={() => {
                            statusReq.changeOrderStatus(r.id, 'active');
                          }}
                          className="edit-button"
                        >
                          <i className="fas fa-refresh"></i>
                        </button>
                      ) : null}
                      {status === 'active' ? (
                        <button
                          title="Завершить"
                          onClick={() => {
                            statusReq.changeOrderStatus(r.id, 'completed');
                          }}
                          className="edit-button"
                        >
                          <i className="fas fa-check"></i>
                        </button>
                      ) : null}
                      {status === 'active' || status === 'completed' ? (
                        <button
                          title="Отменить"
                          onClick={() => {
                            statusReq.changeOrderStatus(r.id, 'canceled');
                          }}
                          className="delete-button"
                        >
                          <i className="fas fa-ban"></i>
                        </button>
                      ) : null}
                      {status === 'canceled' ? (
                        <button
                          title="Удалить навсегда"
                          disabled={deletingId === r.id}
                          onClick={() => handleDelete(r.id)}
                          className="delete-button"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
      {pop ? (
        <PopUp
          message={popMessage}
          status="error"
          setStateFunction={setPop}
          showTime={3000}
        />
      ) : null}
    </div>
  );
};

export default AdminRequests;
